import { render } from "./FilesLoad.vue?vue&type=template&id=91961b18"
import script from "./FilesLoad.vue?vue&type=script&lang=js"
export * from "./FilesLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__